import { Survey, SurveyType } from "@/types/working-model";

const checkIfSurveyIsPoll = (survey?: Survey) => {
	return survey?.survey_type === SurveyType.poll || !!survey?.show_results;
};

export default checkIfSurveyIsPoll;
